<script>
import n2c from "@/common/numberToChinese";
import BgSlider from "./BgSlider.vue";
import modelItem from "./modelItem.vue";
import CountInput from "@/components/common/CountInput.vue";

import { fill, flattenDeep, cloneDeep } from "lodash";
import { endLoading } from "@/http/processing";
const StimulusModeMap = {
  modeList: "刺激模式",
  centralFixation: "中心刺激模式",
  ecCentralFixation: "旁中心刺激模式",
  nystagmus: "眼球震颤刺激模式"
};
export default {
  components: {
    BgSlider,
    CountInput,
    modelItem
  },
  data() {
    const gameType =
      sessionStorage.getItem("gameType") || "FINE_STIMULATION_TRAINING";
    const gameId = sessionStorage.getItem("gameId") || null;
    const gameLevel = parseInt(sessionStorage.getItem("gameLevel")) || null;
    const rolesControl =
      localStorage.getItem("roles").indexOf("ROLE_COMPLIANCE") > -1;
    return {
      typeSource: [
        {
          name: "精细刺激训练",
          type: "FINE_STIMULATION_TRAINING"
        },
        {
          name: "视觉技巧训练",
          type: "VISUAL_SKILL_TRAINING"
        },
        {
          name: "同时视",
          type: "SAME_TIME_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "融合视",
          type: "FUSION_VISION_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "立体视",
          type: "STEREOSCOPIC_BINOCULAR_VISION_TRAINING"
        },
        {
          name: "Gabor训练",
          type: "GABOR_TRAINING"
        },
        {
          name: "对比敏感度训练",
          type: "CONTRAST_SENSITIVITY_TRAINING"
        },
        {
          name: "信息提取训练",
          type: "INFORMATION_EXTRACTION_TRAINING"
        }
      ],
      type: gameType,
      games: [],
      gameId,
      gameLevel,
      gameMaxLevel: 5,
      gameJIngdu: null,
      precision: [],
      bgConfig: null,
      bgs: null,
      ecCentralFixationConfig: [],
      centralFixationConfig: [],
      nystagmusFixationConfig: [],

      staticBgs: [],
      staticBgsCenter: [],
      staticBgsEcCenter: [],
      staticBgsNystagmus: [],

      defaultBgs: [],
      centralFixation: [],
      ecCentricFixation: [],
      nystagmusFixation: [],

      bgRatioData: [],
      bgRatioDataCenter: [],
      bgRatioDataEcCenter: [],
      bgRatioDataNystagmus: [],

      precisionConfig: {
        unit: "像素(px)",
        mix: 1,
        max: 100
      },
      colors: [
        "#86C4EB",
        "#C4BCF0",
        "#86D49F",
        "#F2D895",
        "#F59598",
        "#88EBE4",
        "#EE9BCD",
        "#FFC79F"
      ],
      popoverText: "",
      popVisible: false,
      dotBg: "",
      offsetTop: 0,

      showAddModel: false,
      showAddCentralFixation: false,
      showAddEcCentralFixation: false,
      showAddNystagmus: false,

      showNumberControl: false,
      rolesControl,
      onChangeInput: false,
      StimulusMode: [],
      totalLevel: undefined,
      maxBeginLevel: undefined,
      gameInfo: undefined,
      onChangeLevelInput: false
    };
  },
  computed: {
    hasDiff() {
      let checkStimulusMode = false;
      for (let item in this.StimulusMode) {
        if (
          this.StimulusMode[item].bgs &&
          this.StimulusMode[item].bgs.length > 0
        ) {
          let sizes = this.StimulusMode[item].bgs.map(
            items => items.config.duration.value
          );
          let total = sizes.reduce((item1, item2) => item1 + item2);
          this.StimulusMode[item].bgRatioData = [];
          this.StimulusMode[item].bgs.forEach((obj, index) => {
            let size = obj.config.duration.value;
            this.StimulusMode[item].bgRatioData.push({
              name: obj.name,
              size: size + obj.config.duration.unit,
              ratio: Number((size / total) * 100).toFixed(2) + "%",
              color: this.colors[index % 8]
            });
          });
        }
        if (
          JSON.stringify(this.StimulusMode[item].bgs) !=
          JSON.stringify(this.StimulusMode[item].staticBgs)
        ) {
          checkStimulusMode = true;
        }
      }
      if (
        JSON.stringify(this.staticCongig) != JSON.stringify(this.bgConfig) ||
        checkStimulusMode
      ) {
        return true;
      } else {
        return false;
      }
    },
    levelHasDiff() {
      if (this.gameInfo) {
        if (
          this.gameInfo.totalLevel != this.totalLevel ||
          this.gameInfo.maxBeginLevel != this.maxBeginLevel
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (document.getElementById("spectrum")) {
        this.offsetTop = document.getElementById("spectrum").offsetTop;
      }
    });
  },
  watch: {
    type() {
      this.getGames();
    },
    gameId(gameId) {
      if (gameId) {
        this.getBgs();
      }
    }
  },
  created() {
    this.getGames();
  },
  methods: {
    n2c,
    reset() {
      this.games = [];
      this.gameId = null;
      this.StimulusMode = [];
      this.gameMaxLevel = [];
      this.gameLevel = null;
      this.bgConfig = null;
      this.onChangeInput = false;
    },
    async getGames() {
      this.reset();
      const result = await this.$http.getGameList(this.type);
      this.games = result.data ? result.data.content : [];
      const cacheGameId = sessionStorage.getItem("gameId");
      const cacheGameLevel = parseInt(sessionStorage.getItem("gameLevel"));
      const cacheActiveGame = this.games.filter(o => o.id === cacheGameId);
      if (this.games.length) {
        let activeGame = this.games[0];
        let activeGameLevel = 1;
        if (cacheActiveGame.length > 0) {
          activeGame = cacheActiveGame[0];
          activeGameLevel = cacheGameLevel;
        }
        const gameLevel = activeGameLevel;
        this.gameId = activeGame.id;
        let gameMaxLevel = [];
        for (let i = 1; i <= activeGame.totalLevel; i++) {
          gameMaxLevel.push({
            name: `关卡${i}`,
            key: i
          });
        }
        this.gameMaxLevel = gameMaxLevel;
        this.gameLevel = gameLevel;
        sessionStorage.setItem("gameType", this.type);
      }
    },
    async getBgs() {
      let result = {};
      let defaultResult = {};
      this.StimulusMode = [];
      if (this.gameId) {
        defaultResult = await this.$http.getBGConfigDefault(this.gameId);
        if (this.gameLevel > -1) {
          result = await this.$http.getBGConfig(this.gameId, this.gameLevel);
        }
      }
      if (defaultResult && defaultResult.data) {
        if (result && result.data && result.data.resource) {
          this.totalLevel = result.data.game.totalLevel || undefined;
          this.maxBeginLevel = result.data.game.maxBeginLevel || undefined;
          this.gameInfo = result.data.game;
          let gameMaxLevel = [];
          for (let i = 1; i <= result.data.game.totalLevel; i++) {
            gameMaxLevel.push({
              name: `关卡${i}`,
              key: i
            });
          }
          this.gameMaxLevel = gameMaxLevel;
          for (let item in StimulusModeMap) {
            const StimulusModeItem = {
              bgs: [],
              staticBgs: [],
              defaultBgs: [],
              showAddModel: false,
              shouldShow: false,
              bgRatioData: [],
              modelName: StimulusModeMap[item],
              label: item,
              hasdDiffArr: []
            };
            if (result.data.resource[item]) {
              let tempBgs = result.data.resource[item];
              for (let index in result.data.resource[item]) {
                for (let name in result.data.resource[item][index].config) {
                  let temp = result.data.resource[item][index].config[name];
                  if (temp.storeType === "OSS") {
                    let values = temp.imageList.map(o => o.split("?")[0]);
                    tempBgs[index].config[name].imageList = values;
                  }
                }
              }

              StimulusModeItem.bgs = result.data.resource[item];

              StimulusModeItem.showAddModel = true;
              StimulusModeItem.staticBgs = cloneDeep(
                result.data.resource[item]
              );

              if (item === "ecCentralFixation") {
                StimulusModeItem.defaultBgs =
                  defaultResult.data.ecCentricFixation;
              } else {
                StimulusModeItem.defaultBgs = defaultResult.data[item];
              }
              StimulusModeItem.defaultBgs.forEach(obj => {
                StimulusModeItem.bgs.forEach(objBgs => {
                  if (obj.mode === objBgs.mode) {
                    for (let propsNew in obj.config) {
                      if (!objBgs.config[propsNew]) {
                        StimulusModeItem.hasdDiffArr.push(obj.mode);
                        const temp = cloneDeep(obj.config[propsNew]);
                        objBgs.config[propsNew] = temp;
                      }
                    }
                  }
                });
              });
            }
            if (item === "modeList") {
              StimulusModeItem.shouldShow =
                this.rolesControl && StimulusModeItem.showAddModel;
            } else {
              StimulusModeItem.shouldShow =
                !this.rolesControl && StimulusModeItem.showAddModel;
            }
            this.StimulusMode.push(StimulusModeItem);
          }
          if (result.data.resource.config) {
            let tempBgConfig = cloneDeep(result.data.resource.config);
            for (let name in result.data.resource.config) {
              let item = cloneDeep(result.data.resource.config[name]);
              if (
                item.type === "number" &&
                item.templateName === "TEXT_GROUP_INPUT"
              ) {
                let values = item.value.map(o => parseFloat(o));
                tempBgConfig[name].value = values;
              } else if (item.storeType === "OSS") {
                if (item.templateName === "IMAGE_INPUT") {
                  let values = item.value.split("?")[0];
                  tempBgConfig[name].value = values;
                } else if (item.templateName === "IMAGE_GROUP_INPUT") {
                  let values = item.value.map(o => o.split("?")[0]);
                  tempBgConfig[name].value = values;
                }
              } else if (item.templateName === "SLIDER_RATIO_INPUT") {
                const value = result.data.resource.config[name].value;
                let values = Math.floor(value * 100);
                // console.log("values:", values);
                tempBgConfig[name].value = values;
              }
            }
            this.bgConfig = tempBgConfig;
          } else {
            this.bgConfig = null;
          }
        } else {
          this.StimulusMode = [];
          this.bgConfig = null;
        }
        this.staticCongig = JSON.parse(JSON.stringify(this.bgConfig));
        sessionStorage.setItem("gameId", this.gameId);
        sessionStorage.setItem("gameLevel", this.gameLevel);
      }
    },
    // 融合视：校验初始偏移量需大于等于0且小于等于红蓝偏移量
    checkFusionOffset() {
      if (
        this.type !== "FUSION_VISION_BINOCULAR_VISION_TRAINING" ||
        !this.bgConfig
      ) {
        return true;
      }
      let redBlueOffset;
      let initialOffset;
      for (let name in this.bgConfig) {
        const item = this.bgConfig[name];
        if (!item) continue;
        if (item.name === "红蓝偏移量") {
          redBlueOffset = Number(item.value);
        } else if (item.name === "初始偏移量") {
          initialOffset = Number(item.value);
        }
      }
      // 仅当两项配置同时存在时才校验
      if (redBlueOffset === undefined || initialOffset === undefined) {
        return true;
      }
      if (
        isNaN(initialOffset) ||
        initialOffset < 0 ||
        initialOffset > redBlueOffset
      ) {
        this.$message({
          message: "融合视训练：初始偏移量需大于等于0且小于等于红蓝偏移量",
          type: "error",
          duration: 4000,
          showClose: true
        });
        return false;
      }
      return true;
    },
    async commit() {
      if (!this.checkFusionOffset()) {
        return;
      }
      const checkValue = checkData => {
        checkData.forEach(o => {
          if (typeof o !== "string") {
            o.forEach(item => {});
          }
        });
      };
      let hasBlank = false;
      let returnArr = [];
      for (let StimulusModeItem in this.StimulusMode) {
        let returnBgs = this.StimulusMode[StimulusModeItem].bgs
          ? cloneDeep(this.StimulusMode[StimulusModeItem].bgs)
          : null;
        if (this.StimulusMode[StimulusModeItem].bgs) {
          this.StimulusMode[StimulusModeItem].bgs.forEach((item, index) => {
            if (item.config.color && item.config.color.colorList.length > 0) {
              const arr1 = flattenDeep(item.config.color.colorList).forEach(
                o => {
                  if (o === "") hasBlank = true;
                }
              );
            }
            if (item.config.image && item.config.image.imageList.length > 0) {
              //if oss '?needRefresh=/game/oss/image/refresh'
              if (item.config.image.storeType === "OSS") {
                const arr1 = item.config.image.imageList.map(o => {
                  if (o === "") hasBlank = true;
                  else {
                    return o + "?needRefresh=/game/oss/image/refresh";
                  }
                });
                returnBgs[index].config.image.imageList = arr1;
              }
              const arr1 = item.config.image.imageList.forEach(o => {
                if (o === "") hasBlank = true;
              });
            }
          });
        }
        returnArr.push({
          label: this.StimulusMode[StimulusModeItem].label,
          obj: returnBgs
        });
      }
      let returnBgConfig = this.bgConfig ? cloneDeep(this.bgConfig) : null;
      for (let name in this.bgConfig) {
        let item = cloneDeep(this.bgConfig[name]);
        if (item.storeType === "OSS") {
          if (item.templateName === "IMAGE_INPUT") {
            let values = item.value + "?needRefresh=/game/oss/image/refresh";
            returnBgConfig[name].value = values;
          } else if (item.templateName === "IMAGE_GROUP_INPUT") {
            let values = item.value.map(
              o => o + "?needRefresh=/game/oss/image/refresh"
            );
            returnBgConfig[name].value = values;
          }
        } else if (item.templateName === "SLIDER_RATIO_INPUT") {
          let value = this.bgConfig[name].value;
          let values = parseFloat((value / 100).toFixed(2));
          returnBgConfig[name].value = values;
        } else if (
          item.type === "number" &&
          item.templateName === "TEXT_GROUP_INPUT"
        ) {
          let values = item.value.map(o => parseFloat(o));
          returnBgConfig[name].value = values;
        }
      }

      if (hasBlank) {
        this.$message({
          message: "请填写或删除背景图片或背景颜色",
          type: "error",
          duration: 4000,
          offset: 300,
          showClose: true
        });
      } else {
        const gameConfigData = {
          level: this.gameLevel,
          resource: {}
        };
        if (returnBgConfig) {
          gameConfigData.resource.config = returnBgConfig;
        }
        for (let returnObj in returnArr) {
          if (returnArr[returnObj].obj) {
            gameConfigData.resource[returnArr[returnObj].label] =
              returnArr[returnObj].obj;
          }
        }
        let result = await this.$http.postBGConfig(this.gameId, gameConfigData);
        if (result.data) {
          this.$message.success("提交成功");
          this.getBgs();
        }
      }
    },
    onSelectLevel(level) {
      if (level) {
        this.getBgs();
      }
    },
    onSelectGame(gameId) {
      if (gameId) {
        this.gameLevel = 1;
      }
    },
    valueChange(event, oldValue) {
      if (
        event &&
        event.path &&
        event.path[0] &&
        event.path[0].value != oldValue
      ) {
        this.onChangeInput = true;
      } else {
        this.onChangeInput = false;
      }
    },
    afterInputChange(currentValue, oldValue) {
      // if (currentValue === oldValue) {
      //     this.onChangeInput = false
      // }
      this.onChangeInput = false;
    },
    valueChangeLevel(event, oldValue) {
      if (
        event &&
        event.path &&
        event.path[0] &&
        event.path[0].value != oldValue
      ) {
        this.onChangeLevelInput = true;
      } else {
        this.onChangeLevelInput = false;
      }
    },
    afterInputChangeLevel(currentValue, oldValue) {
      this.onChangeLevelInput = false;
    },
    async updaetLevel() {
      const data = {
        gameId: this.gameId
      };
      if (this.totalLevel) {
        data.totalLevel = this.totalLevel;
      }
      if (this.maxBeginLevel) {
        data.maxBeginLevel = this.maxBeginLevel;
      }
      const result = await this.$http.updateGameLevelManagement(data);
      if (result) {
        this.$message.success("保存成功！");
      }
    }
  }
};
</script>

<template>
  <div class="bgConfig">
    <el-row :gutter="24" class="gameConfigRow">
      <el-col :span="2">
        <p>训练类别：</p>
      </el-col>
      <el-col :span="22" style="padding-left: 0">
        <el-row :gutter="24" class="gameListRow">
          <el-col
            :span="4"
            v-for="typeInfo in typeSource"
            :key="typeInfo.type"
            class="gameConfigCol"
          >
            <el-radio v-model="type" :label="typeInfo.type">{{typeInfo.name}}</el-radio>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="gameConfigRow">
      <el-col :span="6">
        <p class="gameConfigTitle">选择游戏：</p>
        <div>
          <el-select size="mini" v-model="gameId" @change="onSelectGame">
            <el-option v-for="game in games" :key="game.id" :label="game.name" :value="game.id" />
          </el-select>
        </div>
      </el-col>
      <el-col :span="6" v-if="gameMaxLevel.length > 0">
        <p class="gameConfigTitle">选择关卡：</p>
        <div>
          <el-select size="mini" v-model="gameLevel" @change="onSelectLevel">
            <el-option
              v-for="item in gameMaxLevel"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            />
          </el-select>
        </div>
      </el-col>
      <el-col :span="4">
        <p class="gameConfigTitle">总关卡数：</p>
        <div>
          <el-input-number
            v-model="totalLevel"
            class="levelInputNumber"
            size="mini"
            @input.native="(event) => valueChangeLevel(event,totalLevel)"
            @change="afterInputChangeLevel"
            :controls="false"
            :min="0"
            :max="10000"
          ></el-input-number>
        </div>
      </el-col>
      <el-col :span="5">
        <p class="gameConfigTitle">最大起始关卡：</p>
        <div>
          <el-input-number
            v-model="maxBeginLevel"
            class="levelInputNumber"
            size="mini"
            @input.native="(event) => valueChangeLevel(event,maxBeginLevel)"
            @change="afterInputChangeLevel"
            :controls="false"
            :min="0"
            :max="10000"
          ></el-input-number>
        </div>
      </el-col>
      <el-col :span="2" class="gameConfigCol">
        <el-button
          type="primary"
          :disabled="!(levelHasDiff || onChangeLevelInput)"
          size="mini"
          class="updaetLevelButton submitButton"
          @click="updaetLevel"
        >提交起始关卡</el-button>
      </el-col>
    </el-row>
    <el-card shadow="never" class="box-card">
      <div slot="header" class="clearfix">
        <span>关卡{{n2c(gameLevel)}}配置</span>
      </div>
      <div v-if="!bgConfig && !showAddModel && !hasDiff" class="no-defult-config">暂无配置</div>
      <div v-else>
        <el-row v-if="!rolesControl && bgConfig">
          <el-col :span="3" class="tableLayOut">
            <p class="tableLabel">游戏设置</p>
          </el-col>
          <el-col :span="21" class="tableLayOut">
            <div class="numberGroup">
              <div v-for="(item, name) in bgConfig" :key="name" class="numberGroup">
                <p
                  v-if="item.templateName === 'NUMBER_INPUT'"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-input-number
                    v-model="item.value"
                    size="small"
                    @input.native="(event) => valueChange(event,item.value)"
                    @change="afterInputChange"
                    controls-position="right"
                    :min="item.min"
                    :max="item.max"
                  ></el-input-number>
                  {{item.unit}}
                </p>
                <p
                  v-else-if="item.templateName === 'SLIDER_INPUT'"
                  class="config-slider"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-slider
                    v-model="item.value"
                    size="small"
                    @input.native="(event) => valueChange(event,item.value)"
                    show-input
                    :min="item.min"
                    :max="item.max"
                  ></el-slider>
                  {{item.unit}}
                </p>
                <p
                  v-else-if="item.templateName === 'SLIDER_RATIO_INPUT'"
                  class="config-slider"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-slider
                    v-model="item.value"
                    size="small"
                    :step="item.ratio"
                    show-input
                    :min="item.min"
                    :max="item.max"
                  ></el-slider>
                  {{item.unit}}
                </p>
                <p
                  v-else-if="item.templateName === 'IMAGE_INPUT'"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-input v-model="item.value" size="small" class="config-imageGroup"></el-input>
                  {{item.unit}}
                </p>
                <p
                  v-else-if="item.templateName === 'IMAGE_GROUP_INPUT'"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-input
                    v-for="(obj,index) in item.imageList"
                    :key="`${item.name}_${item.templateName}_${index}`"
                    v-model="item.imageList[index]"
                    size="small"
                    class="config-imageGroup"
                  ></el-input>
                </p>
                <p
                  v-else-if="item.templateName === 'TEXT_GROUP_INPUT' && item.type && item.type === 'number'"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-input-number
                    v-for="(obj, index) in item.value"
                    :key="`${item.name}_${item.templateName}_${index}`"
                    v-model="item.value[index]"
                    @input.native="(event) => valueChange(event,item.value[index])"
                    class="bg-input"
                    size="small"
                    :controls="showNumberControl"
                  ></el-input-number>
                  {{item.unit}}
                </p>
                <p
                  v-else-if="item.templateName === 'TEXT_GROUP_INPUT'"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-input
                    v-for="(obj, index) in item.value"
                    :key="`${item.name}_${item.templateName}_${index}`"
                    class="bg-input"
                    size="small"
                    v-model="item.value[index]"
                  ></el-input>
                  {{item.unit}}
                </p>
                <p
                  v-else-if="item.templateName === 'TEXT_AREA_INPUT'"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-input
                    type="textarea"
                    :rows="3"
                    class="config-textarea"
                    placeholder="请输入内容"
                    v-model="item.value"
                  ></el-input>
                </p>
                <p
                  v-else-if="item.templateName === 'SELECTED_INPUT'"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-select v-model="item.selected" class="bg-select">
                    <el-option
                      v-for="selectItem in item.value"
                      :key="`${item.name}_${item.templateName}_${selectItem}`"
                      :label="selectItem"
                      :value="selectItem"
                    ></el-option>
                  </el-select>
                </p>
                <p
                  v-else-if="item.templateName === 'SWITCH_INPUT'"
                  :key="`${item.name}_${item.templateName}`"
                >
                  {{item.name}}
                  <el-switch v-model="item.value"></el-switch>
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
        <modelItem
          v-for="(item, index) in StimulusMode"
          :key="item.modelName + index"
          :bgs="item.bgs"
          :staticBgs="item.staticBgs"
          :defaultBgs="item.defaultBgs"
          :showAddModel="item.showAddModel"
          :bgRatioData="item.bgRatioData"
          :modelName="item.modelName"
          :shouldShow="item.shouldShow"
          :hasdDiffArr="item.hasdDiffArr"
        />
        <el-row>
          <el-col :span="24" class="tableLayOut tableLabel">
            <div class="add-mode">
              <el-button
                type="primary"
                class="submitButton"
                @click="commit"
                :disabled="!(hasDiff || onChangeInput)"
              >提交</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<style lang="scss">
.bgConfig {
  padding-top: 34px;
  overflow: auto;
  height: 100%;
  padding-bottom: 34px;
  box-sizing: border-box;

  .no-defult-config {
    width: 100%;
    height: 300px;
    padding-top: 15%;
    text-align: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.25);
    line-height: 24px;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #00c1de;
    background-color: #fff;
  }

  .el-radio__inner::after {
    background-color: #00c1de;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #00c1de;
    background-color: #00c1de;
  }

  .el-slider__bar {
    background-color: #00c1de;
  }

  .el-slider__button {
    border-color: #00c1de;
  }

  .el-switch.is-checked .el-switch__core {
    border-color: #00c1de;
    background-color: #00c1de;
  }

  .el-switch__label.is-active {
    color: #00c1de;
  }

  .submitButton {
    border-color: #00c1de;
    background-color: #00c1de;
  }

  .configGroup {
    display: flex;
    width: 95%;

    > p {
      width: 116px;
      flex-shrink: 0;
      margin-right: 16px;
      text-align: right;
    }

    > div {
      color: #5d5d5d;
      margin-right: 81px;

      .operationBtn {
        align-items: center;
        display: flex;
        margin-left: 20px;
        color: #3ca8f5;
        cursor: pointer;

        > i {
          margin-right: 10px;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }

  .typeGroup {
    > div {
      display: flex;
      flex-wrap: wrap;
      width: 90%;

      > div {
        width: 157px;
        margin-bottom: 12px;
      }
    }
  }

  .gameSelGroup {
    margin-top: 17px;
    line-height: 32px;
    margin-bottom: 14px;

    > div {
      display: flex;
    }
  }
  .updaetLevelButton {
    height: 30px;
    margin-top: 2px;
  }
  .gameConfigRow {
    width: 95%;
    margin: 14px auto !important;
    line-height: 32px;
    > div {
      display: flex;
      color: #5d5d5d;
    }
    .gameConfigTitle {
      margin-left: 12px;
    }
    > p {
      margin-left: 10px;
      margin-right: 16px;
    }
    .gameConfigCol {
      line-height: 32px;
    }
    .levelInputNumber {
      width: 70px;
    }
  }
  .gameListRow {
    line-height: 32px;
    .gameConfigCol {
      line-height: 32px;
    }
  }

  .box-card {
    width: 95%;
    margin: auto;

    .el-card__header {
      background: #f7f7f7;
    }

    .el-card__body {
      padding: 0;
    }

    .el-row {
      border-top: 1px solid #f2f4f6;
      border-left: 1px solid #f2f4f6;
      border-right: 1px solid #f2f4f6;

      .tableLabel {
        padding: 20px 10px;
      }

      .numberGroup {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        > p {
          padding: 0 20px;
          margin: 10px;
          display: flex;
          align-items: center;

          > div {
            width: 100px;
            // height: ;
            margin: 0 10px;
          }
        }

        .config-slider {
          > div {
            display: inline-block;
            width: 300px;
          }
        }

        .config-textarea {
          width: 250px;
        }

        .config-imageGroup {
          width: 515px;
        }

        .bg-input {
          display: inline-block;
          height: 32px;
          width: 100px;
          padding: 0 5px;
        }
      }

      .radio-select {
        display: flex;

        .el-radio-group {
          display: flex;
        }
      }

      .bg-input-suffix {
        margin: 12px 0px;

        .bg-input {
          display: inline-block;
          height: 32px;
          width: 100px;
          padding: 0 5px;
        }

        .bg-select {
          width: 200px;
        }

        .bg-photo-input {
          width: 515px;
          display: inline-block;
          height: 32px;

          padding: 0 5px;
        }

        .bg-text-button {
          display: inline-block;
        }

        .switch-bg {
          padding: 0 15px;
        }
      }

      .tableLayOut {
        border-top: 1px solid #f2f4f6;
        border-left: 1px solid #f2f4f6;
        border-right: 1px solid #f2f4f6;
      }

      .modeSelect {
        width: 300px;
      }

      .addClass {
        // background-color: #00adc7;

        .add-mode:hover {
          color: #00dafa;
        }

        .add-mode {
          text-align: center;
          margin-left: 20px;
          color: #00adc7;
          cursor: pointer;

          > i {
            margin-right: 10px;
            font-size: 16px;
            font-weight: 500;
          }

          > p {
            display: inline-block;
          }
        }
      }

      .add-mode {
        text-align: center;
        margin-left: 20px;
        color: #00adc7;
        cursor: pointer;

        > i {
          margin-right: 10px;
          font-size: 16px;
          font-weight: 500;
        }

        > p {
          display: inline-block;
        }
      }

      .operationBtn {
        align-items: center;
        display: flex;
        margin-left: 20px;
        color: #00adc7;
        cursor: pointer;

        > i {
          margin-right: 10px;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bgConfig/index.vue